<phoenix-chips
  class="mailing-list-chips"
  [title]="title"
  [showTitle]="false"
  [control]="control"
  [autocompleteConfig]="autocompleteConfig"
  [displayValueFormat]="displayValue"
  [chipIconText]="mailingListIconText"
  chipIconClass="material-icons-outlined text-green-500 text-[22px]"
  chipIconTooltip="IntellihawQ Fileshare"
  [ariaLabel]="ariaLabel"
  [attr.aria-label]="'client-subscription-mailing-lists'"
></phoenix-chips>
